/* eslint-disable react-hooks/exhaustive-deps */
import {
  CheckCircleTwoTone,
  EyeOutlined,
  InboxOutlined,
  LoadingOutlined,
  SaveOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Tooltip,
  message
} from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import CustomDatePicker from '../../components/CustomDatePicker';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import AseguradoraSelect from '../admins/componentes/AseguradoraSelect';

const { Option } = Select;

function PolizaMasivaForm() {
  const [form] = Form.useForm();
  const [fields, setFields] = useState();
  const [polizaDoc, setPolizaDoc] = useState();
  const [loading1, setLoading1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [solicitando, setSolicitando] = useState(false);
  const [productos, setProductos] = useState([]);
  const [riesgos, setRiesgos] = useState([]);
  const [objetos, setObjetos] = useState([]);
  const [tiposRiesgo, setTiposRiesgo] = useState([]);
  const [montos, setMontos] = useState();
  const [aseguradora, setAseguradora] = useState([]);
  const [errorList, setErrorList] = useState([]);
  const [visible, setVisible] = useState(false);

  const history = useHistory();

  const colStyles = {
    display: 'table',
    textAlign: 'center',
    justifyContent: 'center'
  };

  const formatosDoc = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];

  function beforeUpload(file) {
    const isPdf =
      file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    if (!isPdf) {
      message.error('El formato del archivo no está permitido.');
    }
    const isLt10M =
      file.size /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 <
      2;
    if (!isLt10M) {
      message.error('El tamaño del archivo debe ser inferior a 10MB.');
    }
    return isPdf && isLt10M;
  }

  const loadSebaotData = async (params) => {
    try {
      const responseProductos = await instanceRef.instance.get(
        `/sebaot/consultarDatos`,
        {
          params: {
            ...params
          }
        }
      );
      if (responseProductos.data.data.productos) {
        setProductos(responseProductos.data.data.productos);
        setObjetos(responseProductos.data.data.objetos);
        setRiesgos(responseProductos.data.data.riesgos);
        setTiposRiesgo(responseProductos.data.data.tiposRiesgo);
      }
    } catch (error) {
      message.error('Verificar parámetros de Sebaot');
    }
    return false;
  };

  const loadAseguradora = async (id) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(`/aseguradoras/${id}`);
      if (response.data?.data) {
        const {
          sebaot_host,
          sebaot_puerto,
          sebaot_user,
          sebaot_pass,
          parametros
        } = response.data.data;

        await loadSebaotData({
          hostSebaot: sebaot_host,
          puertoSebaot: sebaot_puerto,
          userSebaot: sebaot_user,
          passSebaot: sebaot_pass,
          idAseguradora: id
        });

        if (parametros.montos_poliza_masiva) {
          setMontos(parametros.montos_poliza_masiva);
        }
      }
      setLoading(false);
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  function getAseguradoraId(newValue) {
    if (newValue && newValue.value) {
      setAseguradora(newValue);
    } else {
      setAseguradora();
    }
  }
  useEffect(() => {
    if (aseguradora?.value) {
      loadAseguradora(aseguradora?.value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aseguradora]);
  useEffect(() => {
    const today = moment();
    const polizaValues = {
      fecha_emision: today,
      fechaInicioVig: today,
      fechaFinVig: null,
      aseguradoraEmpresa: undefined, // AseguradoraEempresa,
      observacion: null
    };
    setFields(polizaValues);
    form.setFieldsValue(polizaValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = async (valuesForm) => {
    if (!polizaDoc) {
      message.warning('Debe subir el documento de Póliza Masiva');
      return false;
    }

    try {
      setLoading(true);
      const dataEnviar = {
        poliza: {
          ...fields,
          ...valuesForm,
          idAseguradora: aseguradora.value,
          codigoVehiculoSebaot:
            valuesForm.producto_vehiculo?.split('-')[0] || null,
          seccionVehiculoSebaot:
            valuesForm.producto_vehiculo?.split('-')[1] || null,
          codigoPersonalSebaot:
            valuesForm.producto_personal?.split('-')[0] || null,
          seccionPersonalSebaot:
            valuesForm.producto_personal?.split('-')[1] || null,
          codigoRespCivilSebaot:
            valuesForm.producto_responsabilidad_civil?.split('-')[0] || null,
          seccionRespCivilSebaot:
            valuesForm.producto_responsabilidad_civil?.split('-')[1] || null,
          objetoSebaot: valuesForm.objeto || null,
          riesgoSebaot: valuesForm.riesgo || null,
          tipoRiesgoSebaot: valuesForm.tipo_riesgo || null,
          fechaInicioVig: valuesForm.fechaInicioVig.format('YYYY-MM-DD'),
          fechaFinVig: valuesForm.fechaFinVig.format('YYYY-MM-DD')
        },
        files: { file: polizaDoc }
      };
      setSolicitando(true);
      await instanceRef.instance.post(`archivos/excel`, dataEnviar);

      form.resetFields();
      setLoading(false);
      setSolicitando(false);
      history.push('/solicitudes');
      return null;
    } catch (error) {
      if (error?.response?.data?.message) {
        if (error?.response?.data?.message?.errorList) {
          setErrorList(error?.response?.data?.message?.errorList);
          setVisible(true);
        } else {
          errorHandler(error, 'Error al registrar');
        }
      } else {
        errorHandler(error, 'Error al registrar');
      }
      setLoading(false);
      setSolicitando(false);
      return error;
    }
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const uploadFile = async (file, type, setter) => {
    try {
      setLoading1(true);
      getBase64(file.file, (imageUrl) => {
        setter({
          imagen: imageUrl,
          extension: file.file.type.split('/')[1],
          nombre: `${type}.${file.file.type.split('/')[1]}`
        });
      });
      setLoading1(false);
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      setLoading1(false);
    }
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const PolizaUpload = () => (
    <div>
      <Dragger
        style={{ width: 'auto !important' }}
        name="avatarPoliza"
        accept={formatosDoc}
        listType="picture-card"
        className={`avatar-uploader ${polizaDoc ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) => uploadFile(e, 'PolizaManual', setPolizaDoc)}
        beforeUpload={beforeUpload}
        disabled={loading1}
      >
        <div>
          {loading1 && <LoadingOutlined style={{ fontSize: 20 }} />}
          {!loading1 && (
            <>
              {polizaDoc ? (
                <>
                  <p className="ant-upload-text">Póliza</p>
                  <p className="ant-upload-drag-icon">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              ) : (
                <>
                  <p className="ant-upload-text">Póliza</p>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              )}
            </>
          )}
        </div>
      </Dragger>
    </div>
  );

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Agregar Póliza Masiva"
        style={{ textAlign: 'left' }}
        extra={
          errorList &&
          errorList.length > 0 && (
            <Tooltip title="Ver errores">
              <Button
                type="text"
                icon={<EyeOutlined />}
                size="middle"
                onClick={() => setVisible(true)}
              />
            </Tooltip>
          )
        }
      >
        {fields && (
          <>
            <Spin
              delay={500}
              spinning={loading}
              tip={solicitando && 'En proceso. Aguarde un momento...'}
            >
              <Form
                name="poliza"
                initialValues={fields}
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed()}
                scrollToFirstError
                form={form}
                layout="vertical"
                autoComplete="off"
              >
                <Row
                  gutter={[16, 0]}
                  style={{ maxWidth: '1200px', margin: 'auto' }}
                >
                  <Col xs={24} md={12} align="start" hidden>
                    <Form.Item
                      label="Fecha de emisión"
                      name="fecha_emision"
                      rules={[{ required: true, message: 'Requerido' }]}
                      defaultValue={moment()}
                    >
                      <CustomDatePicker
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Inicio de Vigencia	"
                      name="fechaInicioVig"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <CustomDatePicker
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Fin de Vigencia"
                      name="fechaFinVig"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <CustomDatePicker
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Aseguradora"
                      name="aseguradora"
                      // rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <AseguradoraSelect handleChange={getAseguradoraId} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Producto Vehículo"
                      name="producto_vehiculo"
                    >
                      <Select
                        showSearch
                        allowClear
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: '100%' }}
                        optionFilterProp="children"
                        placeholder="Seleccionar Producto de Sebaot"
                      >
                        {productos.map((itemProducto) => (
                          <Option
                            key={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                            value={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                          >
                            {`${itemProducto.codigo} - ${itemProducto.codigo_seccion} - ${itemProducto.descripcion}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Producto Accidentes Personales"
                      name="producto_personal"
                    >
                      <Select
                        showSearch
                        allowClear
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: '100%' }}
                        optionFilterProp="children"
                        placeholder="Seleccionar Producto de Sebaot"
                      >
                        {productos.map((itemProducto) => (
                          <Option
                            key={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                            value={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                          >
                            {`${itemProducto.codigo} - ${itemProducto.codigo_seccion} - ${itemProducto.descripcion}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <>
                      <Form.Item
                        label="Producto Responsabilidad Civil"
                        name="producto_responsabilidad_civil"
                      >
                        <Select
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          optionFilterProp="children"
                          placeholder="Seleccionar Producto de Sebaot"
                        >
                          {productos.map((itemProducto) => (
                            <Option
                              key={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                              value={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                            >
                              {`${itemProducto.codigo} - ${itemProducto.codigo_seccion} - ${itemProducto.descripcion}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item label="Objeto" name="objeto">
                        <Select
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          optionFilterProp="children"
                          placeholder="Seleccionar Riesgo de Sebaot"
                        >
                          {objetos.map((itemRiesgo) => (
                            <Option
                              key={itemRiesgo.codigo}
                              value={`${itemRiesgo.codigo}`}
                            >
                              {`${itemRiesgo.codigo} - ${itemRiesgo.descripcion}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item label="Riesgo" name="riesgo">
                        <Select
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          optionFilterProp="children"
                          placeholder="Seleccionar Riesgo de Sebaot"
                        >
                          {riesgos.map((itemRiesgo) => (
                            <Option
                              key={itemRiesgo.codigo}
                              value={`${itemRiesgo.codigo}`}
                            >
                              {`${itemRiesgo.codigo} - ${itemRiesgo.descripcion}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item label="Tipo riesgo" name="tipo_riesgo">
                        <Select
                          showSearch
                          allowClear
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: '100%' }}
                          optionFilterProp="children"
                          placeholder="Seleccionar Tipo de Riesgo"
                        >
                          {tiposRiesgo.map((itemTipo) => (
                            <Option
                              key={itemTipo.codigo}
                              value={`${itemTipo.codigo}`}
                            >
                              {`${itemTipo.codigo} - ${itemTipo.descripcion}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item label="Premio Vehículo" name="premio_vehiculo">
                      <Select>
                        {montos &&
                          montos.premio.map((item, index) => (
                            <Option key={index} value={`${item}`}>
                              {`${item}`}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Premio Accidentes Personales"
                      name="premio_personal"
                    >
                      <Select>
                        {montos &&
                          montos.premio.map((item, index) => (
                            <Option key={index} value={`${item}`}>
                              {`${item}`}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Premio Responsabilidad Civil"
                      name="premio_responsabilidad_civil"
                    >
                      <Select>
                        {montos &&
                          montos.premio.map((item, index) => (
                            <Option key={index} value={`${item}`}>
                              {`${item}`}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item label="Observaciones" name="observacion">
                      <Input.TextArea />
                    </Form.Item>
                  </Col>
                </Row>
                <Divider>Subir Documentos</Divider>
                <Row
                  gutter={[16, 0]}
                  justify="center"
                  style={{ textAlign: 'start' }}
                >
                  <Col
                    xs={24}
                    md={12}
                    style={{
                      ...colStyles,
                      marginTop: '50px'
                    }}
                  >
                    <PolizaUpload />
                  </Col>
                </Row>
                <Row justify="center">
                  <div>
                    <Button
                      htmlType="submit"
                      icon={<SaveOutlined />}
                      type="primary"
                      style={{ margin: 20 }}
                    >
                      Guardar
                    </Button>
                  </div>
                </Row>
              </Form>
              {errorList && (
                <Modal
                  title="Lista de errores del archivo"
                  open={visible}
                  onCancel={handleCancel}
                  onOk={handleCancel}
                >
                  <div>
                    <ul>
                      {errorList.map((item, index) => (
                        <li key={index}>
                          {item.id} - {item.error}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Modal>
              )}
            </Spin>
          </>
        )}
      </Card>
    </ResponsiveContainer>
  );
}

export default PolizaMasivaForm;
